import React from 'react';
import styled from 'styled-components';
import { Device } from '../../../../../../../types/Device';
import { CameraTile } from '../CameraTile/CameraTile';
import { defaultConfig, layoutConfigs } from '../CameraTile/consts/configs';

interface CameraGridManualPositionProps {
    viewType: string;
    devices: Device[];
    selectedPosition: number | null;
    onTileClick: (position: number) => void;
    currentDeviceId?: string | null;
}

export const CameraGridManualPosition: React.FC<CameraGridManualPositionProps> = ({
    viewType,
    devices,
    selectedPosition,
    onTileClick,
    currentDeviceId,
}) => {
    const config = layoutConfigs[viewType] || defaultConfig;

    return (
        <StaticGrid cols={config.cols}>
            {config.cameras.map((camera, index) => {
                const device = devices[index];
                return (
                    <CameraTile
                        key={index}
                        device={device}
                        index={index}
                        menuType="edit"
                        onMenuClick={() => {}}
                        onAddDevice={() => {}}
                        isShowNameDevice={true}
                        setIsModalVisible={() => {}}
                        style={{
                            gridColumn: `${camera.x + 1}/span ${camera.width}`,
                            gridRow: `${camera.y + 1}/span ${camera.height}`,
                            border:
                                selectedPosition === index
                                    ? '4px solid var(--tertiary-dark)'
                                    : 'none',
                            opacity: currentDeviceId === device?.UID ? 0.5 : 1,
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            onTileClick?.(index);
                        }}
                        isSelected={selectedPosition === index}
                        disableEmptySlots
                        isCurrentDevice={currentDeviceId === device?.UID}
                        changePosition={true}
                    />
                );
            })}
        </StaticGrid>
    );
};

const StaticGrid = styled.div<{ cols: number }>`
    display: grid;
    width: 100%;
    height: 100%;
    grid-template-columns: repeat(${(p) => p.cols}, 1fr);
    grid-auto-rows: minmax(100px, 1fr);
    gap: 12px;
`;
